import { Component, OnInit } from '@angular/core';
import { first } from "rxjs/operators";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { ZoneService } from 'src/app/services/zone.service';
import { GeofenceService } from "src/app/services/geofence.service";
import { GeofenceZoneService } from "src/app/services/geofencezone.service";
import {CdkDragDrop, moveItemInArray, transferArrayItem, CdkDrag} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-interactive-zone',
  templateUrl: './interactive-zone.component.html',
  styleUrls: ['./interactive-zone.component.scss']
})
export class InteractiveZoneComponent implements OnInit {

  selectedZone = [];
  myZone = [];
  myGeofenceId: any;

  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  public zoneData: any;
  // public selectedZone: any = [];
  public data: any;
  public geofenceZoneData: any;

  constructor(
    public organizationService: OrganizationService,
    public geofenceService: GeofenceService,
    public geofenceZoneService: GeofenceZoneService,
    public zoneService: ZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() {
    this.getAllZone();
    this.getAllGeofence();
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
      else{
        if(this.myZone.includes(event.previousContainer.data[event.previousIndex]) && event.container.connectedTo == "selectedZone"){
          this.toastrService.error("Already exist", "Error");
          return;
        }
        else{
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );}
    }
  }

  getAllGeofence(): void {
    this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.data = response.data;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      });
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
          this.zoneData.forEach(element =>{
            this.selectedZone.push(element.zoneId);
          });
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  getZoneName(zoneId){
    let myObj = this.zoneData.filter(x=>x.zoneId == zoneId)[0];
    // console.log("filter zone",myObj);
    if(myObj == undefined){
      let myZoneName = "Zone Deleted!";
      return myZoneName;
    }
    else{
      let myZoneName = Object.assign({},myObj);
      return myZoneName.zoneName;
    }
  }

  getAllGeofenceZone(geofenceId): void {
    this.selectedZone = []
    this.getAllZone();
    this.myGeofenceId = geofenceId;
    this.myZone = [];
    this.geofenceZoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.geofenceZoneData = response.data.filter(x=>x.geofenceId == geofenceId);
          this.geofenceZoneData.forEach(element =>{
            this.myZone.push(element.zoneId);
          });
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  addGeofenceZoneData(data): void{
    this.geofenceZoneService.addGeofenceZone(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
      }
    })
  }

  saveGeoFenceZone(){
    this.myZone.forEach(zoneid => {
      let payload = {
        geofenceId: this.myGeofenceId,
        zoneId: zoneid,
        organizationId: this.orgId,
        status: 1
      }
      this.addGeofenceZoneData(payload);
    });
  }

  deleteGeofenceZoneByGeofenceId(data): void{
    this.geofenceZoneService.deleteGeofenceZoneByGeofenceId(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        this.saveGeoFenceZone();
      }
    })
  }

}
